module.exports = __webpack_public_path__ + "static/img/5.c3e115b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/sp/5.png
// module id = 2zZA
// module chunks = 0